<!-- Background -->
<div class="h-full w-full bg-app-settings-background md:p-[30px]">

    <!-- Settings container -->
    <div class="rounded-[10px] bg-white w-full h-full flex flex-col p-[30px] ">

        <!-- (Custom) tabs -->
        <div class="custom-tabs mb-4" [ngClass]="{'hidden': breakpoint.md.value}">
            <div class="tabs-container">
                <!-- Users -->
                <a class="tab-container" routerLink="/settings/users" routerLinkActive="selected">
                    <p class="tab-label" i18n>
                        Gebruikers
                    </p>
                </a>

                <!-- Organizations -->
                <a *ngIf="connection.role.value === 'admin'" class="tab-container" routerLink="/settings/organizations"
                    routerLinkActive="selected">
                    <p class="tab-label" i18n>
                        Organisaties
                    </p>
                </a>

                <!-- AI models -->
                <a *ngIf="connection.role.value === 'admin'" class="tab-container" routerLink="/settings/models"
                    routerLinkActive="selected">
                    <p class="tab-label" i18n>
                        Modellen
                    </p>
                </a>
            </div>
            <!-- Bottom bar -->
            <div class="h-[3px] w-full bg-[#BCBCC7] rounded-2xl"></div>
        </div>

        <!-- Side menu and content -->
        <div class="flex flex-row gap-[30px] overflow-x-auto h-full">

            <!-- Menu  -->
            <div class="h-full w-[160px] xl:w-[230px] shrink-0 flex flex-col gap-2"
                [ngClass]="{'hidden': !breakpoint.md.value}">
                <!-- Users -->
                <a class="flex menu-item items-center gap-1" routerLink="/settings/users" routerLinkActive="selected">
                    <mat-icon svgIcon="users" class="scale-75 text-app-global-text-primary"></mat-icon>
                    <p i18n> Gebruikers </p>
                </a>

                <!-- Admin only section -->
                <p *ngIf="connection.role.value === 'admin'" class="font-bold text-base mt-[10px]" i18n>Admin</p>
                <!-- Organizations -->
                <a *ngIf="connection.role.value === 'admin'" class="flex menu-item items-center gap-1"
                    routerLink="/settings/organizations" routerLinkActive="selected">
                    <mat-icon svgIcon="building-2" class="scale-75 text-app-global-text-primary"></mat-icon>
                    <p i18n> Organisaties </p>
                </a>
                <!-- Models -->
                <a *ngIf="connection.role.value === 'admin'" class="flex menu-item items-center gap-1"
                    routerLink="/settings/models" routerLinkActive="selected">
                    <mat-icon svgIcon="bot" class="scale-75 text-app-global-text-primary"></mat-icon>
                    <p i18n> Modellen </p>
                </a>
            </div>

            <div class="w-full h-full grow overflow-auto">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>